import { BaseTextFieldProps, OutlinedInputProps, SlotProps, TextField } from '@mui/material';

import { ElementType } from 'react';
import { NumericFormat } from 'react-number-format';

export interface CurrencyFieldTextProps {
  value: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
  slotProps?: {
    input: SlotProps<
      ElementType<OutlinedInputProps, keyof JSX.IntrinsicElements>,
      {},
      BaseTextFieldProps
    >;
  };
}

export const CurrencyFieldText = ({
  value,
  onChange,
  disabled,
  slotProps
}: CurrencyFieldTextProps) => {
  return (
    <NumericFormat
      value={value}
      decimalScale={2}
      size="small"
      customInput={TextField}
      decimalSeparator=","
      suffix=" €"
      onValueChange={vals => onChange && onChange(vals.floatValue || 0)}
      slotProps={slotProps}
      disabled={disabled}
    />
  );
};
